import { Base } from '@studiometa/js-toolkit';

/**
 * ListingLoadMore component
 */
export default class ListingLoadMore extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ListingLoadMore',
    emits: ['fetch'],
    options: {
      endpoint: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * onClick
   */
  onClick() {
    this.$emit('fetch', this.$options.endpoint);
    this.$destroy();
  }

  /**
   * Destroyed
   */
  destroyed() {
    this.$el.remove();
  }
}
